import { render, staticRenderFns } from "./LmCheckbox.vue?vue&type=template&id=2a573289&"
import script from "./LmCheckbox.vue?vue&type=script&lang=js&"
export * from "./LmCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports